import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext({});

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 检查本地存储中的登录状态
    const checkAuth = () => {
      const token = localStorage.getItem('auth_token');
      const storedUser = localStorage.getItem('auth_user');
      const storedTenant = localStorage.getItem('auth_tenant');
      
      if (token && storedUser && storedTenant) {
        try {
          setUser(JSON.parse(storedUser));
          setTenant(JSON.parse(storedTenant));
          setIsAuthenticated(true);
        } catch (error) {
          console.error('解析存储的用户信息失败:', error);
          localStorage.clear();
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const response = await authService.login(email, password);
      
      // 存储认证信息
      localStorage.setItem('auth_token', response.access_token);
      localStorage.setItem('auth_user', JSON.stringify(response.user));
      localStorage.setItem('auth_tenant', JSON.stringify(response.tenant));
      
      setUser(response.user);
      setTenant(response.tenant);
      setIsAuthenticated(true);
      
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || '登录失败，请检查邮箱和密码' 
      };
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await authService.logout();
    } finally {
      // 清除本地存储
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      localStorage.removeItem('auth_tenant');
      
      // 重置状态
      setUser(null);
      setTenant(null);
      setIsAuthenticated(false);
      
      // 返回成功状态，让调用者处理导航
      return { success: true };
    }
  };

  const updateProfile = (updatedUser) => {
    setUser(updatedUser);
    localStorage.setItem('auth_user', JSON.stringify(updatedUser));
  };

  const updateTenant = (updatedTenant) => {
    setTenant(updatedTenant);
    localStorage.setItem('auth_tenant', JSON.stringify(updatedTenant));
  };

  const value = {
    user,
    tenant,
    isAuthenticated,
    loading,
    login,
    logout,
    updateProfile,
    updateTenant
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};